/**
 * Урл проверки лицензии
 */
export const licenseUrl = "https://license.gochain.space/license/check/";

export const structureUrl = "https://statspy.lineclub.ru/structure";

export const dispatcherUrl = "https://statspy.lineclub.ru/dispatcher";
